<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5_2)">
<mask id="mask0_5_2" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="15">
<path d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z" fill="white"/>
</mask>
<g mask="url(#mask0_5_2)">
<path d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z" fill="#8299A4"/>
<path d="M3.5 8.5C4.05228 8.5 4.5 8.05228 4.5 7.5C4.5 6.94772 4.05228 6.5 3.5 6.5C2.94772 6.5 2.5 6.94772 2.5 7.5C2.5 8.05228 2.94772 8.5 3.5 8.5Z" fill="white"/>
<path d="M7.5 8.5C8.05228 8.5 8.5 8.05228 8.5 7.5C8.5 6.94772 8.05228 6.5 7.5 6.5C6.94772 6.5 6.5 6.94772 6.5 7.5C6.5 8.05228 6.94772 8.5 7.5 8.5Z" fill="white"/>
<path d="M11.5 8.5C12.0523 8.5 12.5 8.05228 12.5 7.5C12.5 6.94772 12.0523 6.5 11.5 6.5C10.9477 6.5 10.5 6.94772 10.5 7.5C10.5 8.05228 10.9477 8.5 11.5 8.5Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_5_2">
<rect width="15" height="15" fill="white"/>
</clipPath>
</defs>
</svg>
